
import { mapActions } from 'vuex';
import AsyncModal from '@/components/common/AsyncModal.vue';
import HorizontalSearchSkeleton from '../skeleton/HorizontalSearchSkeleton.vue';
export default {
  name: 'EmptySearchResult',
  components: { HorizontalSearchSkeleton, AsyncModal },
  data() {
    return {
      isLoading: true,
      teacherClassList: [],
    };
  },
  async created() {
    try {
      this.isLoading = true;

      const res = await this.selectTeacherClass({
        teacherId: this.$route.query.id,
        page: 1,
        limit: 3, // 기획 요구사항 최대 3개
        isPrivate: false,
      });
      this.isLoading = false;
      this.teacherClassList = [...res.items];
    } catch (error) {
      this.isLoading = false;
      console.error(error);
    }
  },
  methods: {
    ...mapActions('teacher', ['selectTeacherClass']),
    moveToTeacherPage() {
      this.$router.push({
        name: 'teacher-id',
        params: {
          id: this.$route.query.id,
          from: 'click_search_more_empty',
        },
      });
    },
  },
};
